import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { Dialog } from 'src/components/shared/dialog/Dialog';
import { ReportComplete } from '../../shared/report/ReportComplete';

export const DreamHistoryReportCompleteDialog: React.FC = () => {
  const params = useParams<{ address?: string }>();
  const { t } = useTranslation('translation');
  const history = useHistory();
  const handleConfirmClick = () => {
    if (params?.address) {
      history.replace(`/players/dream/history/optional-delete/${params.address}`);
    }
  };
  return (
    <Dialog title={t('dialog_report_success')}>
      <ReportComplete onConfirmClick={handleConfirmClick} />
    </Dialog>
  );
};
